export default "__VITE_ASSET__CIOxaWkS__"